import React from "react";
import ReactModal from "react-modal";

const className = {
  base: "gd-rich-editor-modal",
  afterOpen: "gd-rich-editor-modal-open",
  beforeClose: "gd-rich-editor-modal-before-close",
};

const overlayClassName = {
  base: "gd-rich-editor-modal-overlay",
  afterOpen: "gd-rich-editor-modal-overlay-open",
  beforeClose: "gd-rich-editor-modal-overlay-before-close",
};

const Modal = (props) => (
    <ReactModal className={className}
                overlayClassName={overlayClassName}
                bodyOpenClassName="gd-rich-editor-modal-container-open"
                portalClassName="gd-rich-editor-modal-portal"
                ariaHideApp={false}
                {...props}/>
);

export default Modal;
